export default "__VITE_ASSET__DtVnwEuF__"